import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ApiError } from "@anyseal/api-client";
import { BrandMark, Card, StatePanel } from "@anyseal/ui";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { oauthFragment } from "../oauth";

export function OAuthCompletePage() {
  const { locale } = useI18n();
  const { completeOAuth } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<ApiError | Error | null>(null);
  const { flowToken: flow } = oauthFragment(location.hash);
  useEffect(() => {
    if (started.current || !flow) return;
    started.current = true;
    void completeOAuth(flow).then(() => navigate("/", { replace: true })).catch((value: unknown) => setError(value instanceof Error ? value : new Error("OAuth completion failed")));
  }, [completeOAuth, flow, navigate]);
  return <Frame>{!flow ? <StatePanel kind="error" title={locale === "zh-CN" ? "登录链接无效" : "Invalid sign-in link"} action={<Link to="/login">{locale === "zh-CN" ? "返回登录" : "Back to sign in"}</Link>} /> : error ? <StatePanel kind="error" title={locale === "zh-CN" ? "管理员身份验证失败" : "Administrator authentication failed"} description={error.message} requestId={error instanceof ApiError ? error.requestId : undefined} action={<Link to="/login">{locale === "zh-CN" ? "重新登录" : "Try again"}</Link>} /> : <StatePanel kind="loading" title={locale === "zh-CN" ? "正在验证平台权限" : "Verifying platform access"} description={locale === "zh-CN" ? "身份提供商登录完成后仍需通过 LonMax AI 平台权限校验。" : "Identity-provider authentication is followed by a LonMax AI platform authorization check."} />}</Frame>;
}

export function OAuthErrorPage() {
  const { locale } = useI18n();
  const code = new URLSearchParams(location.hash.slice(1)).get("code") ?? "invalid_flow";
  return <Frame><StatePanel kind="error" title={locale === "zh-CN" ? "单点登录未授权" : "Single sign-on was not authorized"} description={code} action={<Link to="/login">{locale === "zh-CN" ? "返回登录" : "Back to sign in"}</Link>} /></Frame>;
}

function Frame({ children }: { children: React.ReactNode }) { return <main className="admin-login"><div className="admin-login__brand"><BrandMark size={28} /><span><strong>LonMax AI</strong><small>CONTROL PLANE</small></span></div><Card className="admin-login-card">{children}</Card></main>; }
